
<div>
  <!-- <div class="sidenav" >
    <button (click)="toggleCollapse()"> <i class="fa fa-solid fa-bars" style="font-size: 25px;margin-top: 40px; background-color: whitesmoke;"></i></button>  
  
   </div> -->
   <div>
    
  <!-- <nav [@onSideNavChange]="collapsed?'close=>open':'open=>close'" *ngIf="modules && collapsed" class="nav"> -->
    <nav [@myInsertRemoveTrigger]="collapsed?':enter':':leave'" *ngIf="modules && collapsed" class="nav">
    <div class="sidenav" >
      <button (click)="toggleCollapse()" class="buttonn"> <i class="fa fa-window-close" style="font-size: 25px;"></i></button>  
    
     </div>
    <ul>
      <!-- <button (click)="toggleCollapse()" class="buttonn"> <i class="fa fa-window-close" style="font-size: 25px;"></i></button>   -->

      <li *ngFor="let mod of modules" class="sidebar-nav">
        <ng-container *ngIf = "mod.modulename !== 'Manage Roles' && mod.modulename !== 'User Reports'">
          
          <a  [ngClass]="{'active' : checkActiveRoute(mod.identifier)}"  routerLink="{{mod.routeLink}}">{{mod.modulename}}</a>

        </ng-container>
        
        </li>
      <li *ngFor="let mod of modules" class="list">
      <ng-container *ngIf = "mod.modulename !== 'Manage Roles' && mod.modulename !== 'User Reports'">
        <!-- <a  [ngClass]="{'active' : checkActiveRoute(mod.identifier)}"  routerLink="{{mod.routeLink}}">{{mod.modulename}}</a> -->
        
        <a (click)="toggleCollapse()" [ngClass]="{'active' : checkActiveRoute(mod.identifier)}"  routerLink="{{mod.routeLink}}">{{mod.modulename}}</a>

        <!-- <a (click)="toggleCollapse()" [ngClass]="{'active' : checkActiveRoute(mod.identifier)}"  routerLink="{{mod.routeLink}}">{{mod.modulename}}</a> -->
      </ng-container>
      
      </li>
     
    </ul>
  </nav>
  </div>
</div>



